import React from "react";
import { withRouter } from "react-router";
import "bootstrap/dist/css/bootstrap.css";

function Condiciones() {
  return (
    <div className="politica-privacidad-condiciones">
      <h3>
        <strong>T&eacute;rminos y condiciones</strong>
      </h3>
      <br></br>
      <h4>Acuerdo de Licencia de Usuario Final</h4>
      <br></br>
      <h5>Aviso importante</h5>
      <p>
        Este acuerdo de licencia de usuario final (<strong>EULA</strong>, por
        sus siglas en ingl&eacute;s) y la Pol&iacute;tica de privacidad (
        <strong>Pol&iacute;tica de privacidad</strong>) (conjuntamente con
        los&nbsp;<strong>T&eacute;rminos y Condiciones</strong>) constituyen el
        acuerdo legal entre Usted (<strong>Usted</strong>&nbsp;o&nbsp;
        <strong>Su</strong>) y el establecimiento&nbsp;(
        <strong>Nosotros</strong>&nbsp;o&nbsp;<strong>Nuestro</strong>)
        relativos a la prestaci&oacute;n por nuestra parte del servicio de
        comunicaci&oacute;n con el establecimiento a trav&eacute;s de cualquiera
        de los medios digitales puestos a disposici&oacute;n (el&nbsp;
        <strong>Servicio</strong>). Lea este EULA y la Pol&iacute;tica de
        privacidad detenidamente. Si no acepta los T&eacute;rminos y
        Condiciones, no permitiremos el acceso al Servicio y el proceso de
        registro se interrumpir&aacute; inmediatamente. Al registrarse y usar el
        Servicio, acepta estar legalmente obligado por los T&eacute;rminos y
        Condiciones.
      </p>
      <h5>T&eacute;rminos acordados</h5>
      <ol>
        <li>
          <strong>Acuse de recibo y consentimiento</strong>
        </li>
      </ol>
      <ol>
        <li>
          Usted reconoce que los T&eacute;rminos y Condiciones (incluidas las
          enmiendas realizadas) se aplican al uso del Servicio (incluyendo
          cualquier actualizaci&oacute;n futura que se le haga) por parte de
          Usted.
        </li>
        <li>
          Usted reconoce y acepta que podemos modificar los T&eacute;rminos y
          Condiciones en cualquier momento. Se le informar&aacute; de todos los
          cambios (si hubiera alguno) por medio de un enlace en la p&aacute;gina
          de inicio de sesi&oacute;n del Servicio. Ser&aacute; necesario que
          Usted lea y acepte cualquier cambio para continuar usando el Servicio.
        </li>
        <li>
          Usted deber&aacute; haber obtenido permiso del propietario de
          cualquier ordenador, tablet, tel&eacute;fono m&oacute;vil, smartphone
          u otro dispositivo electr&oacute;nico (Dispositivo) que Usted utilice
          para acceder al Servicio (y que no sea de su propiedad) para acceder
          al Servicio. Al aceptar los T&eacute;rminos y Condiciones. Usted
          acepta la responsabilidad por el uso del Servicio en cualquier
          Dispositivo sea o no de su propiedad. Usted acepta que Su proveedor de
          servicios podr&iacute;a cobrarle por el acceso a internet a
          trav&eacute;s del Dispositivo.
        </li>
        <li>
          Usted reconoce y acepta que las transmisiones por internet nunca son
          completamente privadas ni seguras y que cualquier informaci&oacute;n
          que Usted env&iacute;e usando el Servicio podr&iacute;a ser
          le&iacute;da o interceptada por otra persona incluso si hay una
          notificaci&oacute;n especial de que una transmisi&oacute;n determinada
          est&aacute; cifrada.
        </li>
        <li>
          Usted da su consentimiento para que recopilemos y utilicemos
          informaci&oacute;n t&eacute;cnica sobre Su Dispositivo (y sobre
          cualquier software, hardware y perif&eacute;ricos relacionados con
          este) para evaluar, mejorar o refinar el Servicio de conformidad con
          la Pol&iacute;tica de Privacidad.
        </li>
        <li>
          Usted da su consentimiento para la transmisi&oacute;n,
          recopilaci&oacute;n, procesamiento, mantenimiento y uso por Nuestra
          parte (y la de Nuestros licenciatarios) de cualquier dato de
          ubicaci&oacute;n enviado desde su Dispositivo para evaluar, mejorar o
          refinar el Servicio de conformidad con la Pol&iacute;tica de
          Privacidad.
        </li>
        <li>
          Usted reconoce que internet es independiente del Servicio y que los
          sitios web a los que Usted acceda a trav&eacute;s del Servicio no
          est&aacute;n bajo Nuestro control y que no somos responsables por ello
          y que no avalamos su contenido ni pol&iacute;ticas de privacidad (si
          las tuvieren). Usted se compromete a usar Su propio discernimiento con
          respecto a la interacci&oacute;n con cualquiera de dichos sitios web
          incluyendo la adquisici&oacute;n de productos o servicios a los que se
          pueda acceder a trav&eacute;s de estos.
        </li>
        <li>
          Usted reconoce y acepta que todos los derechos de propiedad
          intelectual del Servicio (y su tecnolog&iacute;a subyacente) nos
          pertenecen a Nosotros (o a Nuestros licenciantes) y que Usted no tiene
          derechos sobre el Servicio excepto por el derecho exclusivo e
          intransferible de usarlo de conformidad con los T&eacute;rminos y
          Condiciones.
        </li>
      </ol>
      <ol start="2">
        <li>
          <strong>Prestaci&oacute;n del Servicio</strong>
        </li>
      </ol>
      <p>
        Como retribuci&oacute;n a la aceptaci&oacute;n por Su parte de los
        T&eacute;rminos y Condiciones, acordamos prestarle el Servicio hasta el
        momento en que terminemos la prestaci&oacute;n del Servicio para Usted.
        Usted puede dejar de usar el Servicio y Nosotros podemos dejar de
        proveer el Servicio en cualquier momento.
      </p>
      <ol start="3">
        <li>
          <strong>Uso aceptable</strong>
        </li>
      </ol>
      <p>
        Usted acepta que usar&aacute; el Servicio de conformidad con los
        T&eacute;rminos y Condiciones y que no usar&aacute; (y procurar&aacute;
        que ninguna persona que use Su Dispositivo use) el Servicio con fines
        comerciales, ilegales, inmorales o malintencionados, y mientras use el
        Servicio ni Usted (ni ninguna persona que use Su Dispositivo):
      </p>
      <ol>
        <li>
          introducir cualquier c&oacute;digo, virus o datos perjudiciales para
          el Servicio o cualquier sistema operativo; o
        </li>
        <li>
          transmitir, almacenar, publicar o cargar cualquier material
          electr&oacute;nico que pueda ocasionar da&ntilde;os o limitar la
          funcionalidad de cualquier equipo de telecomunicaciones o cualquier
          software o hardware de ordenador; o
        </li>
        <li>
          infringir cualquier derecho de propiedad intelectual que nos
          pertenezca a Nosotros o a terceros; o
        </li>
        <li>
          enviar, recibir, publicar, distribuir, transmitir, cargar o descargar
          cualquier material que sea ofensivo, abusivo, difamatorio, indecente,
          obsceno, ilegal; u objetable de otro modo; o
        </li>
        <li>
          invadir la privacidad u ocasionar molestias o ansiedad o enviar
          cualquier correspondencia no solicitada a cualquier otra persona.
        </li>
      </ol>
      <ol start="4">
        <li>
          <strong>Limitaciones y exclusiones</strong>
        </li>
      </ol>
      <ol>
        <li>
          El Servicio se le presta 'tal cual' y 'seg&uacute;n est&eacute;
          disponible' y por lo tanto todas las garant&iacute;as, condiciones y
          otros t&eacute;rminos impl&iacute;citos en la ley o en el derecho
          com&uacute;n est&aacute;n, en la mayor medida que la ley lo permita,
          excluidos de estos T&eacute;rminos y Condiciones.
        </li>
        <li>
          A excepci&oacute;n de lo previsto en la cl&aacute;usula 4(iv), no
          somos responsables ante Usted por ninguna p&eacute;rdida (directa,
          indirecta o consecuente) ocasionada por fallos, errores, retrasos o
          interrupciones del Servicio, en el Servicio o al Servicio.
        </li>
        <li>
          A excepci&oacute;n de lo previsto en la cl&aacute;usula 4(iv), no
          somos responsables ante Usted si un tercero obtiene acceso a su
          conexi&oacute;n al Servicio o a Su Dispositivo y destruye o
          da&ntilde;a cualquier dato o informaci&oacute;n que Usted tenga o
          informaci&oacute;n sobre Usted que Nosotros tengamos.
        </li>
        <li>
          Ninguna parte de los T&eacute;rminos y Condiciones limitar&aacute; ni
          excluir&aacute; Nuestra responsabilidad ante (a) la muerte o lesiones
          personales que ocurran como consecuencia de Nuestra negligencia, (b)
          fraude o tergiversaci&oacute;n fraudulenta o (c) cualquier otra
          responsabilidad que no pueda ser excluida por ley.
        </li>
      </ol>
      <ol start="5">
        <li>
          <strong>General</strong>
        </li>
      </ol>
      <ol>
        <li>
          Los T&eacute;rminos y Condiciones constituyen la totalidad del acuerdo
          entre Usted y Nosotros en cuanto a la prestaci&oacute;n del Servicio y
          estos (as&iacute; como cualquier controversia o demanda que se
          desprenda de los mismos), son independientemente del lugar desde el
          que se acceda al Servicio y se rigen e interpretan de conformidad con
          las leyes espa&ntilde;olas y tendr&aacute;n jurisdicci&oacute;n
          exclusiva para resolver cualquier controversia o demanda que se
          desprenda o se relacione con estos.
        </li>
        <li>
          Cualquier notificaci&oacute;n de nuestra parte le ser&aacute; enviada
          por correo tradicional o por correo electr&oacute;nico a la
          direcci&oacute;n postal o electr&oacute;nica que Usted nos haya
          proporcionado. Cualquier notificaci&oacute;n de su parte puede
          enviarse por correo tradicional a la direcci&oacute;n del
          Establecimiento o en su defecto a la empresa que provee los servicios
          al establecimiento en C/ Plus Ultra, 5 1&ordm;3, CP 21001 Huelva
          (Espa&ntilde;a) o por correo electr&oacute;nico a
          support@wifreezone.com.
        </li>
      </ol>
      <p>&nbsp;</p>
    </div>
  );
}

export default withRouter(Condiciones);
